import React, { useEffect, useRef } from 'react';
import PricingTable from '../PricingTable/PricingTable';

export default function UserProfileSuccessModal({
	isOpen,
	onClose,
	create_checkout_session_endpoint,
	stripe_public_key,
	stripe_product_essential_id,
	stripe_product_advanced_id,
	stripe_product_ultimate_id
}) {
	const modalRef = useRef(null);

	useEffect(() => {
		if (!isOpen) return undefined;

		const handleClickOutside = (event) => {
			if (modalRef.current && !modalRef.current.contains(event.target)) {
				onClose();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [isOpen, onClose]);

	if (!isOpen) return null;

	return (
		<div
			className="fixed inset-0 flex justify-center items-center"
			style={{
				zIndex: 1000,
				backgroundColor: 'rgba(0, 0, 0, 0.5)'
			}}
		>
			<div
				ref={modalRef}
				className="relative bg-white rounded-lg p-6 shadow-2xl mx-4 md:mx-auto"
				style={{
					width: 'auto',
					maxHeight: '95%',
					overflowY: 'auto',
					maxWidth: '1200px'
				}}
			>
				<button
					className="absolute top-4 right-4 p-2 text-gray-600 hover:text-gray-900 transition-colors"
					onClick={onClose}
				>
					<svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>
				<h2 className="text-xl font-extrabold mb-5 text-gray-800">
					Welcome to Fantasy Fitness!
				</h2>
				<div className="space-y-4 mb-5" style={{ maxWidth: '975px' }}>
					<p className="text-md text-gray-600">
						Enjoy our free features and when you’re ready to take your fantasy fitness to
						the next level, select a plan that's right for you.
					</p>
				</div>
				<div>
					<PricingTable
						create_checkout_session_endpoint={create_checkout_session_endpoint}
						stripe_public_key={stripe_public_key}
						stripe_product_essential_id={stripe_product_essential_id}
						stripe_product_advanced_id={stripe_product_advanced_id}
						stripe_product_ultimate_id={stripe_product_ultimate_id}
					/>
				</div>
				<div className="mt-6 space-y-4">
					<p className="text-gray-800">
						If you have any questions or need assistance, please email{' '}
						<a
							href="mailto:matt@fantasyfitness.io?subject=Inquiry"
							className="text-blue-600 underline hover:text-blue-800"
						>
							matt@fantasyfitness.io
						</a>
					</p>
					<p className="text-gray-800">We hope you enjoy your fantasy fitness journey!</p>
					<p className="text-gray-800">
						Sincerely, <br />
						Matt
					</p>
				</div>
			</div>
		</div>
	);
}
